import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useSuggestionFunctions = () => {
  const { generalApiCall } = useGeneralApiCall();

  const getSuggestion = async ({ prompt, source }) => {
    try {
      const pathname = `/api/copy-suggestion/chat-completion`;
      const method = 'post';
      const requestProperties = {
        messages: [
          {
            role: 'user',
            content: prompt,
          },
        ],
      };
      return await generalApiCall({
        pathname,
        method,
        requestProperties,
        needsAuthentication: true,
        notShowErrorMessage: true,
        requestSource: source,
      });
    } catch (error) {}
  };

  const getResponseToConstituent = async ({ prompt, source }) => {
    try {
      const pathname = `/api/copy-suggestion/response`;
      const method = 'post';
      const requestProperties = {
        input: [
          {
            role: 'user',
            text: prompt,
          },
        ],
      };
      return await generalApiCall({
        pathname,
        method,
        requestProperties,
        needsAuthentication: true,
        notShowErrorMessage: true,
        requestSource: source,
      });
    } catch (error) {}
  };

  const createSummary = async ({ content }) => {
    const prompt = `Summarise: "${content}" into a bullet-point list. Format it as a HTML no ordered list.`;
    return getSuggestion({ prompt });
  };

  return { getSuggestion, createSummary, getResponseToConstituent };
};

export { useSuggestionFunctions };
export default useSuggestionFunctions;
